import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "../contexts/AuthContext/AuthContext";

// Resolve where a signed-in user "belongs" based on their role.
export const homePathForRole = (role) =>
  role === "clinician" ? "/provider/patients" : "/home";

// Guards a route by authentication and (optionally) role.
// - Not signed in        -> redirect to signInPath (default /signin)
// - Wrong role for route  -> redirect to the user's own home
// While auth is still hydrating we render nothing to avoid a premature bounce.
const ProtectedRoute = ({ children, requireRole, signInPath = "/signin" }) => {
  const { isSignedIn, role, isInitializing } = useContext(AuthContext);

  if (isInitializing) {
    return null;
  }

  if (!isSignedIn) {
    return <Navigate to={signInPath} replace />;
  }

  // Only enforce a mismatch once the role is known, so we never bounce a user
  // before their profile has loaded.
  if (requireRole && role && role !== requireRole) {
    return <Navigate to={homePathForRole(role)} replace />;
  }

  return children;
};

export default ProtectedRoute;
